export const Currencies = [
    "ARS",
    "BRL",
    "CLP",
    "COP",
    "EUR",
    "MXN",
    "UAH",
    "USD",
  ];